<template>
    <v-modal ref="modal" @opened="modalOpened" >
        <slot slot="title">{{ $t('country.label.add_new_costs') }}</slot>
        <slot slot="buttonContent">
            <v-block type="mini" height="stretch" color="white">
                <span class="u-flex-set">
                    <button class="c-button c-button--icon-only" type="button">
                        <svgicon name="added"></svgicon>
                    </button>
                </span>
            </v-block>
        </slot>
        <div class="o-wrapper o-wrapper--center">
            <form action="" class="c-form c-form--horizontal">
                <div class="u-max-700 c-form-row">
                    <v-form-row>
                        <v-custom-select v-model="SelectedCurrency"
                                         :options="currencyOptions"
                                         search-label="Code"
                                         option-name="Code"
                                         option-value="Id"
                                         track-by="Id"
                                         :fluid="true"
                                         :multiple="false">
                            <slot slot="label">{{ $t('country.label.currency') }}</slot>
                        </v-custom-select>
                    </v-form-row>
                    <v-form-row>
                        <v-input v-model="Costs.ShippingCosts" name="shippingCosts" type="number" :fluid="true">
                            <slot slot="label">{{ $t('country.label.shipping_costs') }}</slot>
                        </v-input>
                    </v-form-row>
                    <v-form-row>
                        <v-input v-model="Costs.DropShipmentCosts" name="dropShipmentCosts" type="number" :fluid="true">
                            <slot slot="label">{{ $t('country.label.dropshipment_costs') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row>
                        <v-input v-model="Costs.FreeDeliveryShippingCosts" name="freeDeliveryShippingCosts" type="number" :fluid="true">
                            <slot slot="label">{{ $t('country.label.free_delivery_shipping_costs') }}</slot>
                        </v-input>
                    </v-form-row>
                    <v-form-row>
                        <v-input v-model="Costs.FreeDeliveryDropShipmentCosts" name="freeDeliveryDropShipmentCosts" type="number" :fluid="true">
                            <slot slot="label">{{ $t('country.label.free_delivery_dropShipment_costs') }}</slot>
                        </v-input>
                    </v-form-row>

                    <v-form-row>
                        <div class="c-form-item c-form-item--horizontal">
                            <v-label></v-label>
                            <button @click="addNewCosts" type="button" class="c-button c-button--alpha" :disabled="!canAdd">{{ $t('country.button.submit') }}</button>
                        </div>
                    </v-form-row>
                </div>
            </form>
        </div>
    </v-modal>
</template>

<script>
    import VModal from '@/components/modal/Modal'
    import VBlock from '@/components/blocks/Block'
    import VFormRow from '@/components/form/Row'
    import VInput from '@/components/form/Input'
    import VLabel from '@/components/form/Label'
    import VCustomSelect from '@/components/form/CustomSelect'

    // Store
    import {mapGetters} from 'vuex'

    export default {
        components: {
            VModal,
            VBlock,
            VFormRow,
            VInput,
            VLabel,
            VCustomSelect
        },
        data() {
            return {
                Costs: {
                    Id: "00000000-0000-0000-0000-000000000000",
                    ShippingCosts: 0,
                    DropShipmentCosts: 0,
                    CountryId: this.countryId,
                    FreeDeliveryShippingCosts : 0,
                    FreeDeliveryDropShipmentCosts: 0
                },
                SelectedCurrency: {}
            }
        },
        props: {
            countryId: Number,
            currencyOptions: Array
        },
        computed: {
            canAdd(){
                return this.SelectedCurrency.Id && this.SelectedCurrency.Id > 0;
            }
        },
        watch:{
            SelectedCurrency(){
                if(this.canAdd === true) {
                    this.Costs.CurrencyId = this.SelectedCurrency.Id;
                }
            }
        },
        methods: {
            addNewCosts() {
                this.$emit('costsAdded', this.Costs);
                this.$refs.modal.closeDialog();
            },
            modalOpened(){
                this.Costs = {
                    Id: "00000000-0000-0000-0000-000000000000",
                    ShippingCosts: 0,
                    DropShipmentCosts: 0,
                    CountryId: this.countryId,
                    FreeDeliveryShippingCosts : 0,
                    FreeDeliveryDropShipmentCosts: 0
                };
                this.SelectedCurrency = {}
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";
</style>



// WEBPACK FOOTER //
// src/components/countries/AddCosts.vue